import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { DeviceDto } from 'src/app/entities/DeviceDto';
import { filter, map, Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppSettings } from 'src/config/app-setting';
import { OutputDto } from 'src/app/entities/OutputDto';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api.service';
import { ExecuteCommand } from 'src/app/entities/ExecuteCommand';
import { GeoLocationService } from 'src/app/services/geolocation.service';

@Component({
  selector: 'app-device-detail-dialog',
  standalone: false,
  templateUrl: './device-detail-dialog.component.html',
  styleUrl: './device-detail-dialog.component.css'
})
export class DeviceDetailDialogComponent implements OnInit, OnDestroy {
  backdropClickSub!: Subscription;
  isLockButtonEnabled = true;

  private geolocationPosition: GeolocationPosition | undefined;

  constructor(
    private dialogRef: MatDialogRef<DeviceDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { device: DeviceDto, deviceCodPerif: string },
    private dataService: DataService,
    private api: ApiService,
    private geoLocation: GeoLocationService
  ) { }

  device$ = this.dataService.devices$.pipe(
    map(devices => devices.find(d => d.codPerif === this.data.deviceCodPerif)), //trasforma da Device[] di devices$ a Device in device$
    filter((device): device is DeviceDto => device !== undefined) //non emette nulla se non trova un device in devices
  );

  ngOnInit(): void {
    this.backdropClickSub = this.dialogRef.backdropClick().subscribe(() => {
      this.onCancel();
    });

    this.geoLocation.getCurrentPosition().then(pos => {
      this.geolocationPosition = pos;
    });
  }

  ngOnDestroy(): void {
    this.backdropClickSub?.unsubscribe();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: Event) {
    this.onCancel();
  }

  onCancel() {
    this.onClosing();
  }

  onClosing() {
    this.dialogRef.close();
  }

  isLockButtonVisible(device: DeviceDto): boolean {
    const inputIsChiuso = device.lockInput?.fieldValue === device.lockInput?.fieldValueTrue;
    const outputIsApri = device.lockOutput?.fieldValue === device.lockOutput?.fieldValueFalse;

    return (device.lockOutput?.isManual ?? false)
      || (inputIsChiuso && outputIsApri);
  }

  async onLock(device: DeviceDto) {
    if (!device.lockOutput)
      return;

    if (!this.isLockButtonEnabled)
      return;

    this.isLockButtonEnabled = false;

    const codPerif = device.codPerif;
    const currentValue = device.lockOutput.rawValue;
    const isManual = device.lockOutput.isManual;

    const command = new ExecuteCommand({
      outputPort: AppSettings.DeviceSettings.ExecuteCommand.OutputPort,
      source: AppSettings.DeviceSettings.ExecuteCommand.Source,
      pulseDuration: isManual
        ? 0
        : AppSettings.DeviceSettings.ExecuteCommand.AutomaticPulseDurationInseconds,
      codPerif: codPerif,
      value: !currentValue,
      clientLatitude: this.geolocationPosition?.coords.latitude,
      clientLongitude: this.geolocationPosition?.coords.longitude
    });

    //console.log('onLock', command);

    try {
      await this.api.PostDeviceCommand_ExecuteCommand(command);  
    } finally {
      setTimeout(() => { this.isLockButtonEnabled = true; },
        AppSettings.DeviceSettings.LockButtonDebounceInSeconds * 1000);
    }
    
  }
}